import { Component } from '@angular/core';

@Component({
  selector: 'app-users-icon-1',
  templateUrl: './users-icon-1.component.html',
  styleUrl: './users-icon-1.component.scss'
})
export class UsersIcon1Component {

}
